import ViewListIcon from '@material-ui/icons/ViewList';
import NotifLogs from './List/List';
import { CreateSMS } from './Create/Create';

export const notifLogsResource = {
	list: NotifLogs,
	create: CreateSMS,
	icon: ViewListIcon,
}
